import api from "../api/api";

export const AuthService = {
  // customer login
  login: async (phone, password) => {
    const response = await api.post("customer/login", {
      phone,
      password,
    });
    return response.data;
  },

  // customer register
  register: async (name, phone, password) => {
    const response = await api.post("customer/register", {
      name,
      phone,
      password,
    });
    return response.data;
  },
};
